export default __webpack_public_path__ + "static/media/Chiletec.7d9dc92a.svg";